<script setup>
  import { onMounted, getCurrentInstance, onUnmounted } from "vue";
  import { storeToRefs } from "pinia";
  import { useAppearancesStore } from "@stores/appearanceBubbles";
  import { Tooltip } from "@/components/ui/tooltip";

  const appearancesStore = useAppearancesStore();
  const {
    firstThreeAppearances,
    hasMoreThanThreeAppearances,
    hasMoreThanFourAppearances,
    otherAppearancesLength,
    otherAppearancesFullNames,
    surveyId,
  } = storeToRefs(appearancesStore);
  const { fetchAppearances, channelHandlers } = appearancesStore;

  const bubbleClass =
    "flex size-6.5 items-center justify-center overflow-hidden rounded-full bg-episto-teal-700 text-xs font-medium text-white ring-2 ring-background [&+&]:-ml-1";

  const instance = getCurrentInstance();
  const cable = instance.proxy.$cable;

  onMounted(() => {
    cable.subscribe({ channel: "AppearanceChannel", id: surveyId.value });
    cable._addChannel("AppearanceChannel", channelHandlers(cable), {
      _uid: instance.uid,
      _value: instance.proxy,
    });
    fetchAppearances();
  });
  onUnmounted(() => {
    cable.unsubscribe("AppearanceChannel");
  });
</script>

<template>
  <ul class="relative flex items-center justify-center">
    <TransitionGroup
      enter-active-class="transition duration-300 ease-out"
      leave-active-class="absolute transition duration-300 ease-in"
      enter-from-class="scale-25 opacity-0"
      leave-to-class="scale-25 opacity-0">
      <li
        v-for="user in firstThreeAppearances"
        :key="`connected-user-${user.user_id}`"
        :class="bubbleClass">
        <Tooltip>
          <template #content>
            <b>{{ user.full_name }}</b> is also editing
          </template>
          <span>{{ user.initials }}</span>
        </Tooltip>
      </li>
    </TransitionGroup>
    <Transition
      enter-active-class="transition duration-300 ease-out"
      leave-active-class="absolute transition duration-300 ease-in"
      enter-from-class="scale-25 opacity-0"
      leave-to-class="scale-25 opacity-0">
      <li
        v-if="hasMoreThanThreeAppearances"
        :class="bubbleClass">
        <Tooltip>
          <template #content>
            <b>{{ otherAppearancesFullNames }}</b>
            {{ hasMoreThanFourAppearances ? "are" : "is" }} also editing
          </template>
          <span>+{{ otherAppearancesLength }}</span>
        </Tooltip>
      </li>
    </Transition>
  </ul>
</template>
